// @flow

// ----------------------------------------------------------------------
// <copyright file="Izenda.RecordCount.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import localizer from 'share/localization/Izenda.Localizer';
import connect from 'share/enhancers/Izenda.Connect';
import action from './Izenda.PaginatorAction';

@connect(action)
class RecordCount extends Component {
  static propTypes = {
    totalRecords: PropTypes.number.isRequired,
    columns: PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
  }
  static displayName = 'Records Count';

  render() {
    const { totalRecords, columns } = this.props;
    const rowTitle = totalRecords > 1 ? localizer.getText('RECORDS') : localizer.getText('RECORD');
    const columntitle = columns.length > 1 ? localizer.getText('COLUMNS') : localizer.getText('COLUMN');
    return (
      <div className='recordCount'>
        ({localizer.getText('TOTAL')} {totalRecords} {rowTitle}, {columns.length} {columntitle})
      </div>
    );
  }
}

export default RecordCount;



// WEBPACK FOOTER //
// ./ui/share/components/controls/DataGrid/helpers/Izenda.RecordCount.jsx